const getStringTimeInSec = (str) => {
  const [hours, minutes] = str.match(/\d+/g);
  return parseInt(hours) * 60 + parseInt(minutes);
};

export default getStringTimeInSec;
